import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Security, LoginCallback } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import App from './App';
import './index.css';
import { store } from './app/store';
import oktaAuth, { isDebugModeEnabled } from './auth/oktaAuth';
import PrivateRoute from './auth/PrivateRoute';
import { DebugAuthProvider } from './auth/debugAuth';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route element={<PrivateRoute />}>
        <Route path="/*" element={<App />} />
      </Route>
    </>,
  ),
);

const restoreOriginalUri = async (_oktaAuth: typeof oktaAuth, originalUri?: string) => {
  window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
};

// Create the app component with the appropriate auth provider
function AppWithAuth() {
  if (isDebugModeEnabled()) {
    return (
      <DebugAuthProvider>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </DebugAuthProvider>
    );
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </Security>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <AppWithAuth />
);
